import React from 'react';
import { Link } from 'react-router-dom';
import * as PATH from '../CentralisedLink';

const navLinkClass = (isActive) => (
  isActive ? 'nav-link nav-link-style-menu-active' : 'nav-link nav-link-style-menu'
);

const homeNavLinkClass = (isActive, useHomeActiveId) => {
  if (isActive && useHomeActiveId) {
    return 'nav-link nav-link-style-menu-active';
  }
  return navLinkClass(isActive);
};

export const PAESalesNavbarLinks = ({
  activeTab,
  activeTabSales,
  shouldShowDemoCatalogue,
  shouldShowBooking,
  shouldShowPartnerPortal,
  homeLinkId,
}) => (
  <>
    <li className="nav-item">
      <Link
        to="/home"
        className={homeNavLinkClass(activeTabSales === 'HOME', Boolean(homeLinkId))}
        aria-current={activeTabSales === 'HOME' ? 'page' : undefined}
        id={activeTabSales === 'HOME' && homeLinkId ? homeLinkId : undefined}
      >
        Home
      </Link>
    </li>

    {shouldShowDemoCatalogue && (
      <li className="nav-item">
        <Link
          to={`${PATH.DEMO_CATALGUE_PATH}`}
          className={navLinkClass(activeTab === 'DEMO_CATALGUE')}
          aria-current={activeTab === 'DEMO_CATALGUE' ? 'page' : undefined}
        >
          Demo Catalogue
        </Link>
      </li>
    )}

    {shouldShowDemoCatalogue && (
      <li className="nav-item">
        <Link
          to={`${PATH.YADS_INGESTION}`}
          className={navLinkClass(activeTab === 'YADS_INGESTION')}
          aria-current={activeTab === 'YADS_INGESTION' ? 'page' : undefined}
        >
          Narratives Catalogue
        </Link>
      </li>
    )}

    {shouldShowDemoCatalogue && (
      <li className="nav-item">
        <Link
          to={`${PATH.RESET_PATH}`}
          className={navLinkClass(activeTab === 'RESET_DEMO')}
        >
          Reset Demo
        </Link>
      </li>
    )}

    {shouldShowBooking && (
      <li className="nav-item">
        <Link
          to={`${PATH.BOOKING_PATH}`}
          className={navLinkClass(activeTab === 'BOOKING')}
        >
          Booking
        </Link>
      </li>
    )}

    <li className="nav-item">
      <Link
        to={`${PATH.LEARNING_HUB_PATH}`}
        className={navLinkClass(activeTabSales === 'LEARNING_HUB')}
        aria-current={activeTabSales === 'LEARNING_HUB' ? 'page' : undefined}
      >
        Learning Hub
      </Link>
    </li>

    <li className="nav-item">
      <Link
        to={`${PATH.CONTENT_STORE_PATH}`}
        className={navLinkClass(activeTabSales === 'CONTENT_STORE')}
      >
        Content Store
      </Link>
    </li>

    <li className="nav-item">
      <Link
        to={`${PATH.FAQ_PATH}`}
        className={navLinkClass(activeTabSales === 'FAQ')}
      >
        FAQ
      </Link>
    </li>

    {shouldShowPartnerPortal && (
      <li className="nav-item">
        <Link
          to={`${PATH.PARTNER_PORTAL_PATH}`}
          className={navLinkClass(activeTab === 'PARTNER_PORTAL')}
        >
          Partner Portal
        </Link>
      </li>
    )}
  </>
);

export const PAEAdminNavbarLinks = ({
  activeTab,
  activeTabSales,
  shouldShowDemoCatalogue,
  shouldShowBooking,
  shouldShowPartnerPortal,
}) => (
  <>
    <li className="nav-item">
      <Link
        to="/home"
        className={navLinkClass(activeTabSales === 'HOME')}
        aria-current={activeTabSales === 'HOME' ? 'page' : undefined}
      >
        Home
      </Link>
    </li>

    {shouldShowDemoCatalogue && (
      <li className="nav-item">
        <Link
          to={`${PATH.DEMO_CATALGUE_PATH}`}
          className={navLinkClass(activeTab === 'DEMO_CATALGUE')}
          aria-current={activeTab === 'DEMO_CATALGUE' ? 'page' : undefined}
        >
          Demo Catalogue
        </Link>
      </li>
    )}

    {shouldShowDemoCatalogue && (
      <li className="nav-item">
        <Link
          to={`${PATH.YADS_INGESTION}`}
          className={navLinkClass(activeTab === 'YADS_INGESTION')}
          aria-current={activeTab === 'YADS_INGESTION' ? 'page' : undefined}
        >
          Narratives Catalogue
        </Link>
      </li>
    )}

    {shouldShowDemoCatalogue && (
      <li className="nav-item">
        <Link
          to={`${PATH.RESET_PATH}`}
          className={navLinkClass(activeTab === 'RESET_DEMO')}
        >
          Reset Demo
        </Link>
      </li>
    )}

    {shouldShowBooking && (
      <li className="nav-item">
        <Link
          to={`${PATH.BOOKING_PATH}`}
          className={navLinkClass(activeTab === 'BOOKING')}
        >
          Booking
        </Link>
      </li>
    )}

    <li className="nav-item">
      <Link
        to={`${PATH.LEARNING_HUB_PATH}`}
        className={navLinkClass(activeTabSales === 'LEARNING_HUB')}
        aria-current={activeTabSales === 'LEARNING_HUB' ? 'page' : undefined}
      >
        Learning Hub
      </Link>
    </li>

    <li className="nav-item">
      <Link
        to={`${PATH.CONTENT_STORE_PATH}`}
        className={navLinkClass(activeTabSales === 'CONTENT_STORE')}
      >
        Content Store
      </Link>
    </li>

    <li className="nav-item">
      <Link
        to={`${PATH.FAQ_PATH}`}
        className={navLinkClass(activeTabSales === 'FAQ')}
      >
        FAQ
      </Link>
    </li>

    {shouldShowPartnerPortal && (
      <li className="nav-item">
        <Link
          to={`${PATH.PARTNER_PORTAL_PATH}`}
          className={navLinkClass(activeTab === 'PARTNER_PORTAL')}
        >
          Partner Portal
        </Link>
      </li>
    )}
  </>
);
